// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import { CzuPIDFieldContainer } from "./CzuPIDField";

export const overriddenComponents = {
  // Sekce DOI: přepínač „Ano, už mám / Ne, potřebuji" zůstává, ale volba
  // „Ne, potřebuji" místo tlačítka „Získejte DOI nyní!" jen vysvětlí, že DOI
  // přidělí schválení data stewardem. Důvody viz hlavička CzuPIDField.js.
  "InvenioAppRdm.Deposit.PIDField.container": CzuPIDFieldContainer,
};
